import { useTranslation } from "react-i18next";

export default function UsageFlowSection() {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      icon: "ri-user-add-line",
      titleKey: "flow_step1_title",
      descKey: "flow_step1_desc",
    },
    {
      number: "02",
      icon: "ri-bank-card-line",
      titleKey: "flow_step2_title",
      descKey: "flow_step2_desc",
    },
    {
      number: "03",
      icon: "ri-send-plane-fill",
      titleKey: "flow_step3_title",
      descKey: "flow_step3_desc",
    },
  ];

  return (
    <section id="how-it-works" className="py-16 relative overflow-hidden bg-white">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-px bg-gradient-to-r from-transparent via-[#007AFF]/15 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-[#007AFF]/10 border border-[#007AFF]/20 rounded-full px-4 py-1.5 mb-5">
            <span className="text-[#007AFF] text-xs font-semibold tracking-wide uppercase">{t("flow_badge")}</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 tracking-tight">
            {t("flow_title1")}{" "}
            <span className="text-[#007AFF]">{t("flow_titleAccent")}</span>
          </h2>
          <p className="text-gray-500 text-base max-w-md mx-auto">
            {t("flow_subtitle")}
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute top-14 left-[calc(16.67%+3rem)] right-[calc(16.67%+3rem)] h-px bg-gradient-to-r from-[#007AFF]/30 via-[#007AFF]/50 to-[#007AFF]/30" />

          <div className="grid lg:grid-cols-3 gap-10">
            {steps.map((step, index) => (
              <div key={step.number} className="relative flex flex-col items-center text-center group">
                <div className="relative mb-8">
                  <div className="w-28 h-28 rounded-full bg-[#eff6ff] border-2 border-[#c7dcff] flex items-center justify-center group-hover:border-[#007AFF]/50 group-hover:bg-[#ebf3ff] transition-all duration-300 relative z-10">
                    <i className={`${step.icon} text-4xl text-[#007AFF]`} />
                  </div>
                  <div className="absolute -top-1 -right-1 w-7 h-7 gradient-accent rounded-full flex items-center justify-center z-20 shadow-sm">
                    <span className="text-white text-xs font-bold">{index + 1}</span>
                  </div>
                </div>

                <h3 className="text-gray-900 font-bold text-xl mb-3">{t(step.titleKey)}</h3>
                <p className="text-gray-500 text-sm leading-relaxed max-w-xs">{t(step.descKey)}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row items-center justify-center gap-6 text-center bg-[#f8fafd] rounded-2xl px-8 py-5 border border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-[#ebf3ff] rounded-lg">
              <i className="ri-time-line text-[#007AFF] text-lg" />
            </div>
            <span className="text-gray-500 text-sm">
              {t("flow_avgSetup")} <strong className="text-gray-900">{t("flow_2min")}</strong>
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-gray-200" />
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center bg-[#ebf3ff] rounded-lg">
              <i className="ri-customer-service-2-line text-[#007AFF] text-lg" />
            </div>
            <span className="text-gray-500 text-sm">
              {t("flow_support")} <strong className="text-gray-900">{t("flow_supportTime")}</strong>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
